'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002410 from "./presto.-Presto$$anon$10.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$9() {
  this.bbA = null;
  this.bbs = null;
  this.bbt = false;
  this.bbB = null;
  this.bbC = false;
  this.bbF = null;
  this.bby = null;
  this.bbz = false;
  this.bbu = null;
  this.bbv = false;
  this.bbw = null;
  this.bbx = false;
  this.bbD = false;
  this.bbE = false;
  this.bbA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbF = "CompactFeature";
}
export { $c_Lpresto_Presto$$anon$9 as $c_Lpresto_Presto$$anon$9 };
$p = $c_Lpresto_Presto$$anon$9.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$9;
/** @constructor */
function $h_Lpresto_Presto$$anon$9() {
}
export { $h_Lpresto_Presto$$anon$9 as $h_Lpresto_Presto$$anon$9 };
$h_Lpresto_Presto$$anon$9.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bbA;
});
$p.M = (function() {
  if ((!this.bbt)) {
    this.bbs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbt = true;
  }
  return this.bbs;
});
$p.O = (function() {
  if ((!this.bbC)) {
    this.bbB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bbC = true;
  }
  return this.bbB;
});
$p.E = (function() {
  return this.bbF;
});
$p.t = (function() {
  if ((!this.bbz)) {
    this.bby = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbz = true;
  }
  return this.bby;
});
$p.N = (function() {
  if ((!this.bbv)) {
    this.bbu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().adf(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bbv = true;
  }
  return this.bbu;
});
$p.Q = (function() {
  if ((!this.bbx)) {
    this.bbw = new $j_presto$002e$002dPresto$0024$0024anon$002410.$c_Lpresto_Presto$$anon$10();
    this.bbx = true;
  }
  return this.bbw;
});
$p.v = (function() {
  if ((!this.bbE)) {
    this.bbD = false;
    this.bbE = true;
  }
  return this.bbD;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.acT(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_Presto$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$9, "presto.Presto$$anon$9", ({
  Nt: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$9 as $d_Lpresto_Presto$$anon$9 };
//# sourceMappingURL=presto.-Presto$$anon$9.js.map
